import { createActions, createReducer } from 'reduxsauce';

import { updateProp } from 'Reducers/shared';

export const { Types, Creators } = createActions(
  {
    getDonorCitiesByPostCodeSuccess: ['payload'],
    set: ['payload'],
    setDonorAddresses: ['payload'],
    updateProp: ['key', 'value']
  },
  { prefix: 'postCodes/' }
);

const initialState = {
  donorAddresses: [],
  list: [],
  selectedPostcodes: []
};

export const set = (state, { payload }) => ({
  ...state,
  list: [...new Set(payload)]
});

export const setDonorAddresses = (state, { payload }) => ({
  ...state,
  donorAddresses: [...new Set(payload)]
});

export const getDonorCitiesByPostCodeSuccess = (state, { payload }) => {
  state.cities = payload;

  return { ...state };
};

export default createReducer(initialState, {
  [Types.GET_DONOR_CITIES_BY_POST_CODE_SUCCESS]: getDonorCitiesByPostCodeSuccess,
  [Types.SET_DONOR_ADDRESSES]: setDonorAddresses,
  [Types.SET]: set,
  [Types.UPDATE_PROP]: updateProp
});

export const postCodesAddressesList = state => state.postCodes.list;
export const donorAddresses = state => state.postCodes.donorAddresses;
export const selectedPostcodes = state => state.postCodes.selectedPostcodes;
